module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts3.bc74a445.png";